<template>
  <el-form label-position="top" :model="packType" :rules="rules" ref="packTypeForm">
    <div>
      <el-switch
        v-model="packType.is_active"
        style="margin-bottom: 23px;"
        active-text="Aktív"
      />
    </div>
    <div>
      <el-switch
        v-model="packType.available_in_webshop"
        style="margin-bottom: 33px;"
        active-text="Webshopban elérhető"
      />
    </div>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Kiszereléstípus"
          prop="pack_type"
        >
          <el-select
            v-if="packTypes && packTypes.length"
            v-model="packType.pack_type"
            value-key="id"
            style="width: 100%;"
            :default-first-option="true"
            @change="packType.pack_type_id = packType.pack_type.id"
          >
            <el-option
              v-for="type in packTypes"
              :key="type.id"
              :value="type"
              :label="type.name"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Darab/kiszerelés"
          prop="count_per_pack"
        >
          <el-input-number
            v-model.number="packType.count_per_pack"
            style="width: 100%;"
            precision=0
            :min="1"
          />
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Kiszerelés/sor"
          prop="count_per_row"
        >
          <el-input-number
            v-model="packType.count_per_row"
            style="width: 100%;"
            :precision="0"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Netto súly"
          prop="weight"
        >
          <el-input-localized-numeric
            v-model="packType.weight"
          >
            <template slot="append">kg</template>
          </el-input-localized-numeric>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Brutto súly"
          prop="gross_weight"
        >
          <el-input-localized-numeric
            v-model="packType.gross_weight"
          >
            <template slot="append">kg</template>
          </el-input-localized-numeric>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Magasság"
          prop="height"
        >
          <el-input-localized-numeric
            v-model="packType.height"
          >
            <template slot="append">mm</template>
          </el-input-localized-numeric>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          label="Szélesség"
          prop="width"
        >
          <el-input-localized-numeric
            v-model="packType.width"
          >
            <template slot="append">mm</template>
          </el-input-localized-numeric>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Hosszúság"
          prop="length"
        >
          <el-input-localized-numeric
            v-model="packType.length"
          >
            <template slot="append">mm</template>
          </el-input-localized-numeric>
        </el-form-item>
      </el-col>
    </el-row>
    <p-table
      v-if="packType.ean_codes"
      ref="eanItems"
      :opts="{
        currency: 'HUF',
        addItem: true,
        updateItem: true,
        deleteItem: true,
        editableFields: [],
      }"
      dialog="EanDialog"
      :columns="[
        {
          label: 'EAN kód',
          prop: 'ean',
          minWidth: 100,
        },
        {
          label: 'Beszállító',
          prop: 'supplier_name',
          showTooltip: true,
        },
      ]"
      :data="packType.ean_codes"
      :empty-line="{
        supplier_id: null,
        supplier_name: null,
        product_id: null,
        product_pack_type_id: null,
      }"
    />
  </el-form>
</template>

<script>
import PTable from '../../../../../utils/PTable';

export default {
  components: { PTable },
  props: ['defaultPackType', 'formType'],
  data() {
    const checkValue = (rule, value, callback) => {
      if(!value) {
        return callback();
      }
      if (isNaN(parseFloat(value)) || (typeof value === 'string' && !value.match(/^\d*\.?\d*?$/))) {
        return callback(new Error('Ez a mező csak számokat tartalmazhat'));
      }
      return callback();
    };
    return {
      packType: {
        is_active: true,
        count_per_pack: 1,
        barcode: '',
        ean_codes: null
      },
      rules: {
        pack_type: [
          {
            required: true,
            message: 'Kiszereléstípus megadása kötelező',
            trigger: 'change'
          }
        ],
        count_per_pack: [
          {
            required: true,
            message: 'Darab/kiszerelés megadása kötelező',
            trigger: 'change'
          }
        ],
        weight: [
          { validator: checkValue, trigger: 'change' }
        ],
        gross_weight: [
          { validator: checkValue, trigger: 'change' }
        ],
        height: [
          { validator: checkValue, trigger: 'change' }
        ],
        width: [
          { validator: checkValue, trigger: 'change' }
        ],
        length: [
          { validator: checkValue, trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    packTypes() {
      return this.$store.getters['packType/packTypes'];
    },
  },
  watch: {
    defaultPackType: {
      handler(newVal) {
        this.packType = Object.assign({}, newVal);
      },
      deep: true,
    },
  },
  async mounted() {
    await this.$store.dispatch('packType/fetchAll');
    if (this.formType === 'add') {
      this.packType = {
        is_active: true,
        count_per_pack: 1,
        pack_type_id: this.packTypes && this.packTypes.length && this.packTypes[0].id || null,
        pack_type: this.packTypes && this.packTypes.length && this.packTypes[0] || null,
        ean_codes: []
      };
    } else {
      this.packType = Object.assign({}, this.defaultPackType, {});
    }
  },
};
</script>
